import React from 'react';

import {
  CONFIGURATOR_BREAKPOINTS,
  CONFIGURATOR_DESKTOP_BREAKPOINT,
  CONFIGURATOR_SMARTPHONE_BREAKPOINT,
} from '../constants';
import { ConfiguratorBreakpoint, ConfiguratorBreakpointClickHandler, ConfiguratorContextBreakpoint } from '../types';

export function useBreakpoints() {
  const [breakpoint, setBreakpoint] = React.useState<ConfiguratorBreakpoint>(CONFIGURATOR_SMARTPHONE_BREAKPOINT);
  const [modalBreakpoint, setModalBreakpoint] = React.useState<ConfiguratorBreakpoint>(CONFIGURATOR_DESKTOP_BREAKPOINT);
  const [openPreviewModal, setOpenPreviewModal] = React.useState<boolean>(false);

  const handleBreakpointClick = React.useCallback<ConfiguratorBreakpointClickHandler>((nextBreakpoint) => {
    setBreakpoint(nextBreakpoint);
  }, []);

  const handleModalBreakpointClick = React.useCallback<ConfiguratorBreakpointClickHandler>((nextBreakpoint) => {
    setModalBreakpoint(nextBreakpoint);
  }, []);

  const handlePreviewModalToggle = React.useCallback(() => {
    setOpenPreviewModal((prevState) => !prevState);
  }, []);

  const breakpoints = React.useMemo<ConfiguratorContextBreakpoint[]>(() => {
    return CONFIGURATOR_BREAKPOINTS.map((configuratorBreakpoint) => ({
      ...configuratorBreakpoint,
      active: configuratorBreakpoint.id === breakpoint.id,
      onClick: () => handleBreakpointClick(configuratorBreakpoint),
    }));
  }, [breakpoint, handleBreakpointClick]);

  const modalBreakpoints = React.useMemo<ConfiguratorContextBreakpoint[]>(() => {
    return CONFIGURATOR_BREAKPOINTS.map((configuratorBreakpoint) => ({
      ...configuratorBreakpoint,
      active: configuratorBreakpoint.id === modalBreakpoint.id,
      onClick: () => handleModalBreakpointClick(configuratorBreakpoint),
    }));
  }, [modalBreakpoint, handleModalBreakpointClick]);

  return React.useMemo(
    () => ({
      breakpoint,
      breakpoints,
      modalBreakpoint,
      modalBreakpoints,
      openPreviewModal,
      onPreviewModalToggle: handlePreviewModalToggle,
    }),
    [breakpoint, breakpoints, modalBreakpoint, modalBreakpoints, openPreviewModal, handlePreviewModalToggle],
  );
}
